<template>
  <drag-dialog
    :visible.sync="visible"
    :title="`${activeId ? '编辑' : '新增'}设备信息`"
    width="900px"
    height="600px"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm', 'devTypeOptions')"
  >
    <el-form disabled v-loading="editLoading" :model="editForm" ref="editForm" label-width="120px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="12">
          <el-form-item label="设备编号" prop="devCode">
            <el-input v-model.trim="editForm.devCode" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="设备名称" prop="devName">
            <el-input v-model.trim="editForm.devName" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="出厂编号" prop="mid">
            <el-input v-model.trim="editForm.mid" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="制造商" prop="producer">
            <el-input v-model.trim="editForm.producer" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="型号规格" prop="devModel">
            <el-input v-model.trim="editForm.devModel" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="购入日期" prop="buyDate">
            <el-date-picker
              v-model="editForm.buyDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="购入金额" prop="assetValue">
            <el-input type="number" v-model.trim="editForm.assetValue" placeholder="请输入">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="出厂日期" prop="dom">
            <el-date-picker
              v-model="editForm.dom"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="设备类别" prop="devType">
            <el-select v-model="editForm.devType" placeholder="请选择" clearable>
              <el-option v-for="item in devTypeOptions" :key="item.code" :label="item.name" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="设备状态" prop="state">
            <el-select v-model="editForm.state" placeholder="请选择">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="仪器精度" prop="accuracy">
            <el-input v-model="editForm.accuracy" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="技术参数" prop="params">
            <el-input type="textarea" v-model="editForm.params" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" v-model="editForm.remark" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import { getDictsByCode } from '@/api/system';
import { getDeviceById } from '@/api/device';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      editLoading: false,
      editForm: {
        quantity: 1,
        assetValue: 0,
        checkPeriod: 1,
        state: 1
      },
      statusOptions: [
        {
          label: '合格',
          value: 1
        },
        {
          label: '停用',
          value: -1
        },
        {
          label: '报废',
          value: -2
        }
      ],
      devTypeOptions: [],
      submitLoading: false
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val && this.activeId) {
        this.getDetailData();
      }
      if (val && this.devTypeOptions.length == 0) {
        this.getDictsByCode('device_type', 'devTypeOptions');
      }
    }
  },
  methods: {
    async getDetailData() {
      this.editLoading = true;
      try {
        const { data } = await getDeviceById({ id: this.activeId });
        this.editForm = {
          id: data.id,
          devName: data.devName,
          devCode: data.devCode,
          checkCertNo: data.checkCertNo,
          checkOrg: data.checkOrg,
          lsCheckTime: data.lsCheckTime,
          nxCheckTime: data.nxCheckTime,
          devModel: data.devModel,
          accuracy: data.accuracy,
          mid: data.mid,
          params: data.params,
          quantity: data.quantity,
          pos1: data.pos1,
          pos2: data.pos2,
          remark: data.remark,
          assetValue: data.assetValue,
          checkPeriod: data.checkPeriod,
          state: data.state,
          dom: data.dom,
          producer: data.producer,
          devType: data.devType,
          batch: data.batch,
          quality: data.quality,
          buyDate: data.buyDate
        };
      } finally {
        this.editLoading = false;
      }
    },
    // 获取字典
    async getDictsByCode(code, dataType) {
      const { data } = await getDictsByCode({ code });
      this[dataType] = data ?? [];
    }
  },
  created() {},
  mounted() {}
};
</script>

<style scoped>
.el-select,
.el-input,
.el-autocomplete {
  width: 100%;
}

.el-button--mini.is-circle {
  padding: 5px;
}
</style>
